import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from './NavBar/NavBar';
import HomePage from './HomePage/HomePage';
import EventDetails from './EventDetails/EventDetails';
import Login from './Login/Login';
import SignUp from './SignUp/SignUp';
import Profile from './Profile/Profile';
import About from './About/About';
import Contact from './Contact/Contact';
import { AuthProvider } from './AuthContext';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <NavBar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/event/:id" element={<EventDetails />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
